export const UNBRIDLED_PHONE = "310-877-1257";
export const UNBRIDLED_PHONE_HREF = "tel:+13108771257";
export const UNBRIDLED_EMAIL = "durrtom11@gmail.com";
export const UNBRIDLED_HOMEPORT = "San Pedro, California";

export type UnbridledTrip = {
  slug: string;
  name: string;
  duration: string;
  price: string;
  blurb: string;
  highlights: string[];
  target: string[];
};

export const UNBRIDLED_TRIPS: UnbridledTrip[] = [
  {
    slug: "four-hour",
    name: "4-Hour Half Day",
    duration: "4 hours",
    price: "$1,050",
    blurb:
      "The classic short trip out of San Pedro. Perfect for kids, first-timers and anyone who wants steady bites without committing to a full day on the water.",
    highlights: [
      "Private 4-pack — up to four anglers",
      "Local breakwall, flats and structure",
      "Rods, reels and terminal tackle aboard",
      "Back at the dock in time for lunch",
    ],
    target: ["Calico bass", "Sand bass", "Barracuda", "Bonito", "Sculpin"],
  },
  {
    slug: "seven-hour",
    name: "7-Hour Extended Local",
    duration: "7 hours",
    price: "$1,600",
    blurb:
      "Extra hours buy a lot of water. Tom can run past the harbor and work deeper structure or chase whatever is showing up on the local scanners that morning.",
    highlights: [
      "More range than the 4-hour trip",
      "Rockfish grounds and outer structure in season",
      "Best local shot at yellowtail and white seabass",
      "Catch cleaned and bagged before you leave",
    ],
    target: ["Calico bass", "Rockfish", "Yellowtail", "White seabass", "Barracuda"],
  },
  {
    slug: "catalina-island",
    name: "10-Hour Catalina Island",
    duration: "10 hours",
    price: "$2,400",
    blurb:
      "The full island run. Cross the channel and fish Catalina's legendary kelp lines, boils and structure — the trip this coast is famous for.",
    highlights: [
      "Full day at Catalina Island",
      "Kelp beds, island structure and blue water",
      "Best shot at yellowtail, seabass and island calicos",
      "Up to four anglers, whole-boat private",
    ],
    target: ["Yellowtail", "White seabass", "Calico bass", "Barracuda", "Bonito"],
  },
  {
    slug: "all-day-marlin",
    name: "All Day Marlin",
    duration: "All day",
    price: "$2,500",
    blurb:
      "When the marlin show, this is the trip. An all-day offshore run hunting striped marlin on the troll, the kite and the flyer — a true big-game day.",
    highlights: [
      "All-day offshore big-game hunt",
      "Trolling, live bait and sight casting",
      "Prime season only — call for timing",
      "Up to four anglers, whole-boat private",
    ],
    target: ["Striped marlin", "Yellowfin tuna", "Dorado", "Yellowtail"],
  },
];

export const UNBRIDLED_FEATURES = [
  {
    title: "60+ years local",
    body: "Captain Tom Durr has fished this stretch of coast his entire life. He knows which spots produce on which tide, and he doesn't waste your hours finding out.",
  },
  {
    title: "Private 4-pack",
    body: "Every trip is whole-boat with a maximum of four anglers. No shared rail, no crowding, no waiting your turn on a hot corner.",
  },
  {
    title: "Gear provided",
    body: "Quality rods, reels and terminal tackle are aboard. Bring a hat, sunscreen, a jacket and your fishing license.",
  },
  {
    title: "Book direct",
    body: "No booking platform, no middleman. Call Tom, pick a date and get on the water — often the same week.",
  },
];

export const UNBRIDLED_FAQ = [
  {
    q: "How many anglers can come?",
    a: "Unbridled is a 4-pack, so up to four anglers per trip. Pricing is whole-boat — the cost is the same whether you bring one friend or three.",
  },
  {
    q: "Where do we leave from?",
    a: "All trips depart from San Pedro, California. Tom will confirm the exact dock and departure time when you book.",
  },
  {
    q: "Do I need a fishing license?",
    a: "Yes — every angler 16 and older needs a valid California sport fishing license. One-day licenses can be bought online before your trip.",
  },
  {
    q: "What should I bring?",
    a: "Sun protection, a jacket for the run, food and drinks, and anything you'd like to keep your catch in. Rods, reels and tackle are provided.",
  },
  {
    q: "What if the weather turns?",
    a: "Safety first. If conditions are unfishable Tom will call you to move the trip to the next workable date.",
  },
  {
    q: "Are there open party trips?",
    a: "Yes — open party trips are being scheduled and will be announced on Friedman Adventures as dates are set.",
  },
];